import { render, staticRenderFns } from "./alarms-expand-panel-more-infos.vue?vue&type=template&id=17a1461c&scoped=true&"
import script from "./alarms-expand-panel-more-infos.vue?vue&type=script&lang=js&"
export * from "./alarms-expand-panel-more-infos.vue?vue&type=script&lang=js&"
import style0 from "./alarms-expand-panel-more-infos.vue?vue&type=style&index=0&id=17a1461c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1461c",
  null
  
)

export default component.exports